<template>
  <div v-if="show" class="footer">
    <MCounter v-model="quantity" :can-add="canAdd" :can-re="canRe" @overflow="onOverflow" />
    <MButton
      class="add"
      primary
      :disabled="!isCanAdd"
      :loading="props.loading"
      @click="emit('add', quantity)"
    >
      <span bold>
        {{ isRecommend ? $t('common.add') : $t('details.addCart') }}
      </span>
      <template #loading>
        <q-circular-progress
          indeterminate
          size="16px"
          color="white"
          class="q-mr-xs"
          :thickness="0.3"
        />
      </template>
    </MButton>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, inject } from 'vue';
import MButton from 'src/components/MButton/index.vue';
import MCounter from 'src/components/MCounter/index.vue';
import { use18n, useIns, useStore } from '../../../utils/v2_helper/common';
import { useRoute } from '../../../utils/v2_helper/router';

const props = defineProps({
  inStock: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  max: {
    type: Number,
    default: Infinity,
  },
  stock: {
    type: Number,
    default: Infinity,
  },
});
const emit = defineEmits(['add']);

const store = useStore();
const app = useIns();
const { $t } = use18n();
const route = useRoute();

const quantity = ref(1);
const min = ref(0);
const steps = ref(1);

const scheduled = computed(() => store.state.Menu.scheduled);
const show = computed(() => {
  const { status } = app.storeInfo || {};
  if (!status) return false;
  return status !== 400;
});
const isCanAdd = computed(() => {
  if (!props.inStock) return false;
  if (quantity.value < 1) return false;
  // 允许加购的数量为0也要禁用
  if (props.max === 0) return false
  if (scheduled.value) return true;
  const { statusCode } = app.storeInfo.status || false;
  if (statusCode && statusCode !== 200) return false;
  return true;
});
const canAdd = computed(
  () => props.inStock && quantity.value < (props.max !== null ? props.max : Infinity),
);
const canRe = computed(
  () => props.inStock && quantity.value > (min.value || 0),
);

// ==
const recommend = inject('isRecommend');
const isRecommend = computed(() => {
  if (route.query.tag) {
    return route.query.tag?.indexOf('recommend') >= 0;
  }
  return recommend.value;
});

// 处理库存不够事件
function onOverflow() {
  app.$message.error($t('list.stockError', [props.stock || 0]))
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 64px;
  padding: 0 16px;
  background: $grayBg;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .add {
    width: 220px;
    height: 40px;
  }
  .count {
    font-weight: bold;
    font-size: 20px;
    display: flex;
    align-items: center;
    &-item {
      background: $dark;
      color: #fff;
      position: relative;
      width: 28px;
      height: 28px;
      &.dis {
        pointer-events: none;
        background: $disabledBg;
        color: $disabledFont;
      }
      i {
        font-size: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      border-radius: 50%;
    }
    &-text {
      padding: 0 12px;
    }
  }
}
</style>
